module.exports = __webpack_public_path__ + "fonts/AvenirLTStd-Medium.c87a8e47.woff";